import { z } from 'zod';
import { scoreSchema } from '../../validation';

export const regionScoresSchema = z.object({
  /** the amount trucks available in that region
   *
   * `High number is good` - `low number is bad`
   */
  supply: scoreSchema,

  /** the amount trucks available in a near by region
   *
   * `High number is good` - `low number is bad`
   */
  nearbySupply: scoreSchema,

  /** the amount orders available in that region
   *
   * `High number is good` - `low number is bad`
   */
  demand: scoreSchema,
  /** the amount orders available in a nearby region
   *
   * `High number is good` - `low number is bad`
   */
  nearbyDemand: scoreSchema,

  /**
   * this measure the legal Prevention Time for the region.
   *
   * short time is good which means the driver does not have to spend a lot time waiting for the Prevention time to end.
   *
   * `High number is good` - `low number is bad`
   */
  shortPreventionTime: scoreSchema,

  /**
   * good Road means there are well established roads, and no mountains which can makes it difficult for drivers and cloud cost more diesel.
   *
   * So it's better for the driver to go to region where it has no mountains which is considered an easy/good road.
   *
   * `High number is good` - `low number is bad`
   */
  goodRoad: scoreSchema,
});
export type RegionScores = z.infer<typeof regionScoresSchema>;
